<template>
    <div class="modal fade" id="basic" tabindex="-1" role="basic" aria-hidden="true" style="display: none;">
        <div class="modal-dialog">
            <div class="modal-content">
                <div class="modal-header">
                    <button type="button" class="close" data-dismiss="modal" aria-hidden="true"></button>
                    <h4 class="modal-title">Copier le lien de partage de votre vidéo</h4>
                </div>
                <div class="modal-body">
                    <div class="portlet light" style="border: 1px solid #C2CAD8; margin-right: 1em;" :disabled="active.youtube">
                        <label class="control-label">Vidéo Youtube</label>

                        <input type="" class="form-control" name="Youtube" value="" placeholder="Exemple: https://youtu.be/fi-S9lrnLZ8" :disabled="dalymotion != '' || vimeo != ''" v-model="youtube" />
                    </div
                    <span class="modalSpanCustom">Ou</span>
                    <div class="portlet light" style="border: 1px solid #C2CAD8; margin-right: 1em;" :disabled="active.vimeo">
                        <label class="control-label">Vidéo Viméo</label>

                        <input type="" class="form-control" name="Vimeo" value="" placeholder="https://player.vimeo.com/video/288364753" :disabled="youtube != '' || dalymotion != ''" v-model="vimeo" />
                    </div>
                    <span class="modalSpanCustom">Ou</span>
                    <div class="portlet light" style="border: 1px solid #C2CAD8; margin-right: 1em;" :disabled="active.dailymotion">
                        <label class="control-label">Vidéo Dailymotion</label>

                        <input type="" class="form-control" name="Dailymotion" value="" placeholder="https://www.dailymotion.com/embed/video/x48oiw" :disabled="youtube != '' || vimeo != ''" v-model="dalymotion" />
                    </div>
                    <div class="row">
                        <div class="col-xs-12">
                            <button type="button" class="btn green">Sauvegarder</button>
                            <button type="button" class="pull-right btn default" data-dismiss="modal">Fermer</button>
                        </div>
                    </div>
                    <input type="text" name="videoEmbed" :value="input">
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {

  name: 'modalVideoLinks',

  data () {
    return {
        active: {
            youtube: false,
            vimeo: false,
            dailymotion: false,
        },
        youtube: '',
        vimeo: '',
        dalymotion: ''
    }
  },
  computed: {
    input: function() {
        if (this.youtube != '') {
            return this.youtube
        }
        if (this.dalymotion != '') {
            return this.dalymotion
        }
        if (this.vimeo != '') {
            return this.vimeo
        }
    }
  }
}
</script>

<style lang="css" scoped>
</style>
